module.exports = __webpack_public_path__ + "img/businessTag.65a05f49.png";